module.exports = __webpack_public_path__ + "media/images/about/history/president-1-da4eaa6f071ba953efd737a7230fd180.png";